const { default: axiosIns } = require('@/libs/axios')

const PrebidService = {
  // GET - PrebidDashboardController
  async getPrebidDashboard() {
    return axiosIns.get('admin/prebid/dashboard').then(response => response.data)
  },
  // POST - PrebidDashboardController
  async getStats(filter) {
    return axiosIns.post('admin/prebid/dashboard/chart', filter).then(response => response.data)
  },
  async getAdapterStats(filter) {
    return axiosIns.post('admin/prebid/dashboard/adapter', filter).then(response => response.data)
  },
}

export default PrebidService
